
import axios from 'axios';

export default {
  data() {
    return {
      centerDialogVisible: false,
      searchQuery: '',
      listData: []
    };
  },
  methods: {
    showSearchDialog() {
      this.centerDialogVisible = true
    },
    handleSelect(item) {
      this.$emit('getAddress', item)
    },
    querySearchAsync(queryString, cb) {
      if (this.searchQuery.length > 2) {
        axios.get(`https://restapi.amap.com/v3/assistant/inputtips?keywords=${this.searchQuery}&key=d27b5be7b1d38c445913e8b265a29525&city=深圳&citylimit=true&datatype=all`).then(res => {
          this.listData = res.data.tips.map(item => {
            return {
              address: item.district + item.address,
              value: item.name,
              location: item.location
            }
          });
          cb(this.listData)
        })
      }
    },
  }
}
